var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"caption text-center"},[_c('span',{staticClass:"letter"},[_vm._v(_vm._s(_vm.letter))]),_c('div',{staticClass:"tab-contents"},[_c('span',{staticClass:"title"},[_vm._v("———————")]),_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"title"},[_vm._v("———————")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }